import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { Redirect } from 'react-router-dom';
import ErrorModal from '../../components/_molecules/ErrorModal/ErrorModal';
import LinkedinLoginButton from './components/LinkedinLoginButton';
import GoogleLoginButton from './components/GoogleLoginButton/GoogleLoginButton';
import { ERROR } from '../../utils/constants';


class SocialLoginWrapper extends Component {
    static propTypes = {
      socialRegistration: PropTypes.func.isRequired,
      id: PropTypes.number.isRequired,
      email: PropTypes.string.isRequired,
      havePassword: PropTypes.bool.isRequired,
      profile: PropTypes.shape({}).isRequired,
      setUser: PropTypes.func.isRequired,
      annulError: PropTypes.func.isRequired,
      status: PropTypes.string.isRequired,
      error: PropTypes.string.isRequired,

      externalLogin: PropTypes.func.isRequired,
    }

    componentDidUpdate(prevProps) {
      if (this.props.id !== prevProps.id) {
        const {
          email, havePassword, id, profile,
        } = this.props;
        this.props.setUser({
          email, havePassword, id, profile,
        });
        this.props.externalLogin();
      }
    }

    login = (data) => {
      this.props.socialRegistration(data);
    }

    render() {
      const {
        status, error, annulError,
      } = this.props;
      const isError = status === ERROR;
      return (
        <React.Fragment>
          <ErrorModal requestClose={annulError} visible={isError} error={error} />
          <LinkedinLoginButton login={this.login} />
          <GoogleLoginButton login={this.login} />
        </React.Fragment>
      );
    }
}

export default SocialLoginWrapper;



// WEBPACK FOOTER //
// ./src/containers/SocialLoginWrapper/SocialLoginWrapper.js